module.exports = __webpack_public_path__ + "static/img/avatar.4e4e289.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatar.jpg
// module id = odpv
// module chunks = 16